// Export（shouldPrerenderOnExportTarget）时，按设计，不执行任何业务 App/Page 代码
// 而 Next 在 export 时，server 执行 getInitialProps/constructor，client 仅执行 constructor
// 曾使用 client 快速路由的方式实现（路由变化时会执行 getInitialProps），但对业务代码时序提出了更高要求，容易因为副作用出现BUG
// 调整为在 client constructor 手动控制 App 渲染的方式实现
// 仅变更业务 App/Page 代码的执行时序，不变更框架时序。使得框架层按 Next 原始时序工作，业务层按自定义时序工作（业务层本身不应该过度依赖 next 时序，随时可能调整）

import React from 'react'

export function withExportCompatibility(TargetApp) {
  function shouldExportEmptyFunc(ctx) {
    // _error 无影响
    return (
      (ctx.__AL_EX_internalScope.runtimeConfig.frameworkConfig.mode ===
        'export' ||
        ctx.__AL_EX_internalScope.runtimeConfig.frameworkConfig
          .isGeneratedByExport) &&
      !ctx.__AL_EX_internalScope.runtimeConfig.frameworkConfig
        .shouldPrerenderOnExportTarget
    )
  }

  return class extends React.PureComponent {
    static displayName = `fwAppWithExportCompatibility(${
      TargetApp.displayName || TargetApp.name || 'App'
    })`

    static async getInitialProps(appCtx) {
      let initialProps
      if (!shouldExportEmptyFunc(appCtx.ctx)) {
        if (TargetApp.getInitialProps) {
          initialProps = await TargetApp.getInitialProps(appCtx)
        }
      } else {
        initialProps = { pageProps: {} }
      }
      return initialProps
    }

    constructor(props) {
      super(props)
      const shouldExportEmpty = shouldExportEmptyFunc(props.ctx)
      this.state = {
        shouldRenderApp: !shouldExportEmpty,
        extraInjectedAppProps: null,
      }
      if (process.browser && shouldExportEmpty) {
        this.handleExportOnClient()
      }
    }

    // 在 client 模拟执行 getInitialProps
    handleExportOnClient() {
      // 模拟系统创建的appCtx
      const appCtx = {
        AppTree: undefined, // 不确定是否会产生异常
        Component: this.props.Component,
        router: this.props.router,
        ctx: this.props.ctx,
      }
      if (TargetApp.getInitialProps) {
        TargetApp.getInitialProps(appCtx).then(
          (initialProps) => {
            // 尽管异步，但通过 render null 的方式，保证了业务代码 constructor 时状态已正确
            this.setState({
              shouldRenderApp: true,
              extraInjectedAppProps: initialProps,
            })
          },
          (err) => {
            // 冗余代码
            throw err
          }
        )
      } else {
        // constructor 同步时序
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.shouldRenderApp = true
      }
    }

    render() {
      return this.state.shouldRenderApp ? (
        <TargetApp
          {...{ ...this.state.extraInjectedAppProps, ...this.props }}
        />
      ) : (
        // 需要增加 null 的判断，未提供时返回 null，否则 react 报错
        // 先暂时和 next-plugin-al-hydrate-loading 冗余，待调整
        <div
          style={{
            zIndex: 2147483647,
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%,-50%)',
            transformOrigin: '50% 50%',
            display: 'block', // 注意此处
          }}
          dangerouslySetInnerHTML={{
            __html:
              this.props.ctx.__AL_EX_internalScope.runtimeConfig.frameworkConfig
                .hydrateLoadingContent || '',
          }}
        />
      )
    }
  }
}
